import React, { useState } from 'react';
import { EmojiProvider } from 'react-apple-emojis';

import { TourProvider, useTour } from '@reactour/tour';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight, faTimes } from '@fortawesome/free-solid-svg-icons';
import { enableBodyScroll, disableBodyScroll } from 'body-scroll-lock';

import emojiData from '../emoji/data.json';

import IconButton from '../buttons/IconButton';
import { doArrow } from '../../modules/tours/helpers';

import './Tour.scss';

function Arrow({ inverted, disabled }) {
  return (
    !disabled && (
      <div className="arrow" data-testid={`tour-overview-${inverted ? 'next' : 'prev'}-button`}>
        <IconButton className="px-3">
          <FontAwesomeIcon className="text-one f-std-bold" icon={inverted ? faChevronRight : faChevronLeft} />
        </IconButton>
      </div>
    )
  );
}

function Close({ onClick, skippable = false }) {
  const { currentStep, steps } = useTour();

  if (!skippable && currentStep !== steps.length - 1) return null;

  return (
    <div className="close">
      <IconButton className="px-3" onClick={onClick}>
        <FontAwesomeIcon className="text-one f-std-bold" icon={faTimes} />
      </IconButton>
    </div>
  );
}

function Tour({ steps, children, closeAction, skippable = false }) {
  const [disabledKeys] = useState(['esc']);

  const enableBody = (target) => {
    if (!target) return;
    enableBodyScroll(target);
  };
  const disableBody = (target) => {
    if (!target) return;
    disableBodyScroll(target);
  };

  const closeTour = ({ setIsOpen, currentStep, setCurrentStep }) => {
    if (!skippable && currentStep !== steps.length - 1) return;

    setIsOpen(false);
    closeAction(currentStep === steps.length - 1);
    setCurrentStep(0);
    window.scrollTo(0, 0);
  };

  return (
    <EmojiProvider data={emojiData}>
      <TourProvider
        steps={steps}
        styles={{
          maskArea: (base) => ({ ...base, rx: 12 }),
          popover: (base, state) => ({
            height: 'fit-content',
            marginTop: '30px',
            ...base,
            ...doArrow(state.position, state.verticalAlign, state.horizontalAlign),
          }),
        }}
        padding={{ popover: [30, 20] }}
        components={{
          Arrow,
          Close: (props) => <Close skippable={skippable} {...props} />,
        }}
        onClickClose={closeTour}
        onClickMask={closeTour}
        afterOpen={disableBody}
        beforeClose={enableBody}
        disableKeyboardNavigation={disabledKeys}
        scrollSmooth
      >
        {children}
      </TourProvider>
    </EmojiProvider>
  );
}

export function ScrollableContent({ children }) {
  return <div className="reactour__scrollable">{children}</div>;
}

export default Tour;
